"use client";

import { useEffect, useState } from "react";

type FormData = {
  first_name: string;
  last_name: string;
  email: string;
  city: string;
};

type HiddenField = {
  name: string;
  value: string;
};

const hiddenFields: HiddenField[] = [
  {
    name: "lead_source",
    value: "Landing Page",
  },
  {
    name: "program",
    value: "M.S in Data Science",
  },
  {
    name: "form_name",
    value: "MSDS Form1",
  },
  {
    name: "university",
    value: "IIT Chicago X Mahindra University",
  },
];

export default function CTAForm() {
  const [formData, setFormData] = useState<FormData>({
    first_name: "",
    last_name: "",
    email: "",
    city: "",
  });

  // OTP state
  const [phone, setPhone] = useState("+91");
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState<string | null>(null);
  const [otpExpiry, setOtpExpiry] = useState<number>(0);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  // Hidden fields + UTM parameters
  const [mergedHiddenFields, setMergedHiddenFields] =
    useState<HiddenField[]>(hiddenFields);

  // Cooldown countdown
  useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setInterval(() => {
      setCooldown((current) => (current > 0 ? current - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldown]);

  // Merge UTM parameters into hidden fields
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const utmFields: HiddenField[] = [
      {
        name: "utm_source",
        value: params.get("utm_source") || "",
      },
      {
        name: "utm_medium",
        value: params.get("utm_medium") || "",
      },
      {
        name: "utm_campaign",
        value: params.get("utm_campaign") || "",
      },
      {
        name: "utm_term",
        value: params.get("utm_term") || "",
      },
      {
        name: "utm_content",
        value: params.get("utm_content") || "",
      },
    ];

    setMergedHiddenFields([...hiddenFields, ...utmFields]);
  }, []);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  // Generate and send OTP
  const handleSendOtp = async () => {
    if (!/^\+91\d{10}$/.test(phone)) {
      alert("Please enter a valid +91 followed by 10 digits.");
      return;
    }

    if (cooldown > 0) {
      alert(`Please wait ${cooldown} seconds before resending.`);
      return;
    }

    const newOtp = Math.floor(
      100000 + Math.random() * 900000
    ).toString();

    const expiresAt = Date.now() + 5 * 60 * 1000;

    setGeneratedOtp(newOtp);
    setOtpExpiry(expiresAt);
    setOtpVerified(false);
    setCooldown(30);

    const message = `Dear user,
Your OTP for verification is ${newOtp}.
Please do not share this with anyone.
- B EDEPT`;

    const params = new URLSearchParams({
      user: "Edept_sms",
      pass: "123456",
      sender: "BEDEPT",
      phone,
      text: message,
      priority: "ndnd",
      stype: "normal",
    });

    try {
      await fetch(
        `http://bhashsms.com/api/sendmsg.php?${params.toString()}`,
        {
          method: "GET",
          mode: "no-cors",
        }
      );

      setShowOtp(true);
      alert("OTP sent on your mobile, please check.");
    } catch (error) {
      console.error("SMS send error:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  // Verify OTP
  const verifyOtp = () => {
    if (!generatedOtp) {
      alert("Please request OTP first.");
      return;
    }

    if (Date.now() > otpExpiry) {
      alert("OTP expired. Please request a new one.");
      setGeneratedOtp(null);
      setShowOtp(false);
      console.log(otpVerified)
      setOtp("");
      return;
    }

    if (otp.trim() === generatedOtp) {
      setOtpVerified(true);
      setGeneratedOtp(null);
      setShowOtp(false);
      setOtp("");
      alert("OTP verified successfully!");
      console.log(otpVerified)
      return;
    }

    setOtpVerified(false);
    alert("Invalid OTP. Please try again.");
  };

  return (
    <form
      method="post"
      action="https://align-together-edept.odoo.com/webform/submit/mas-ds"
      className=" w-full max-w-md rounded-2xl bg-white py-2"
    >
      {/* Hidden Fields */}
      {mergedHiddenFields.map((field) => (
        <input
          key={field.name}
          type="hidden"
          name={field.name}
          value={field.value}
        />
      ))}


      <div className="space-y-4">
        {/* First + Last Name */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              First Name
            </label>

            <input
              type="text"
              name="first_name"
              placeholder="John"
              value={formData.first_name}
              required
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 p-3 text-gray-700 outline-none focus:ring-2 focus:ring-[#2f5ea8]"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Last Name
            </label>

            <input
              type="text"
              name="last_name"
              placeholder="Doe"
              value={formData.last_name}
              required
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 p-3 text-gray-700 outline-none focus:ring-2 focus:ring-[#2f5ea8]"
            />
          </div>
        </div>

        {/* Phone */}
       {/* Phone */}
<div>
  <label className="mb-1 block text-sm font-medium text-gray-700">
    Phone
  </label>

  <div className="relative">
    <input
      type="tel"
      name="phone"
      value={phone}
      onChange={(event) => {
        const value = event.target.value;

        if (value.startsWith("+91")) {
          setPhone(value);
        } else {
          setPhone("+91");
        }

        setOtpVerified(false);
      }}
      placeholder="Enter phone number"
      className="
        w-full
        rounded-md
        border border-gray-300
        p-3
        pr-32
        text-gray-700
        outline-none
        focus:ring-2
        focus:ring-[#2f5ea8]
      "
    />

    <button
      type="button"
      onClick={() => {
        setShowOtp(true);
        handleSendOtp();
      }}
      disabled={cooldown > 0 || otpVerified}
      className="
        absolute
        right-0
        top-0
        h-full
        rounded-r-md
        border-l border-gray-300
        px-3
        text-sm
        font-medium
        text-[#12539F]
        transition-colors
        hover:bg-gray-50
        disabled:cursor-not-allowed
        disabled:text-gray-400
      "
    >
      {otpVerified
        ? "Verified"
        : cooldown > 0
          ? `Resend ${cooldown}s`
          : "Verify"}
    </button>
  </div>
</div>

  {/* OTP */}
  {showOtp && (
    <div>
      <label className="mb-1 block text-sm font-medium text-gray-700">
        Enter OTP
      </label>

      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={otp}
          onChange={(event) => setOtp(event.target.value)}
          placeholder="Enter 6-digit OTP"
          className="
            w-full
            rounded-md
            border border-gray-300
            p-3
            pr-28
            text-gray-700
            outline-none
            focus:ring-2
            focus:ring-[#2f5ea8]
          "
        />

        <button
          type="button"
          onClick={verifyOtp}
          className="
            absolute
            right-0
            top-0
            h-full
            rounded-r-md
            border-l border-gray-300
            px-3
            text-sm
            font-medium
            text-[#12539F]
            transition-colors
            hover:bg-gray-50
          "
        >
          Verify OTP
        </button>
      </div>
    </div>
  )}


        {/* Email */}
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Email Address
          </label>

          <input
            type="email"
            name="email"
            placeholder="john.doe@email.com"
            value={formData.email}
            required
            onChange={handleChange}
            className="w-full rounded-lg border border-gray-300 p-3 text-gray-700 outline-none focus:ring-2 focus:ring-[#2f5ea8]"
          />
        </div>

        {/* City */}
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            City
          </label>

          <input
            type="text"
            name="city"
            placeholder="Mumbai"
            value={formData.city}
            required
            onChange={handleChange}
            className="w-full rounded-lg border border-gray-300 p-3 text-gray-700 outline-none focus:ring-2 focus:ring-[#2f5ea8]"
          />
        </div>
      </div>

{/* Submit */}
<button
  type="submit"
  id="submit"
  disabled={!otpVerified}
  className={`
    mb-2
    mt-5
    w-full
    rounded-xl
    py-3
    text-lg
    font-semibold
    text-black
    transition-colors
    ${
      otpVerified
        ? "cursor-pointer bg-[#EDA12E] hover:bg-[#d99126]"
        : "cursor-not-allowed bg-gray-400 opacity-60"
    }
  `}
>
  Submit
</button>
    </form>
  );
}